// Stato pipeline in sessionStorage per persistenza cross-page
const KEY = "activePipeline";
const COLLAPSE_KEY = "pipelineDrawerCollapsed";

// EventEmitter minimale basato su StorageEvent e dispatch custom
const listeners = new Set();

function emitChange() {
    listeners.forEach(fn => {
        try { fn(); } catch { }
    });
    // Trucchetto per notificare anche la stessa tab
    const e = new Event("pipeline-change");
    window.dispatchEvent(e);
}

export function onPipelineChange(cb) {
    listeners.add(cb);
    window.addEventListener("storage", cb);
    window.addEventListener("pipeline-change", cb);
}

export function offPipelineChange(cb) {
    listeners.delete(cb);
    window.removeEventListener("storage", cb);
    window.removeEventListener("pipeline-change", cb);
}

export function getActivePipeline() {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function setActivePipeline(board) {
    const payload = { active: true, board, currentIndex: 0, startedAt: Date.now() };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
    emitChange();
}

export function updatePipelineIndex(nextIndex) {
    const p = getActivePipeline();
    if (!p) return;
    const payload = { ...p, currentIndex: nextIndex };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
    emitChange();
}

export function clearActivePipeline() {
    sessionStorage.removeItem(KEY);
    emitChange();
}

export function setDrawerCollapsed(collapsed) {
    sessionStorage.setItem(COLLAPSE_KEY, JSON.stringify(!!collapsed));
    // non serve emitChange grafico, ma utile per sync
    try {
        window.dispatchEvent(new StorageEvent("storage", { key: COLLAPSE_KEY }));
    } catch {
        const e = new Event("storage");
        window.dispatchEvent(e);
    }
}

export function getDrawerCollapsed() {
    try {
        return JSON.parse(sessionStorage.getItem(COLLAPSE_KEY) || "false");
    } catch {
        return false;
    }
}
